<template>
  <GroupItemCard :imgBackground="imgBackground" @openItem="goToCourse">
    <template #img>
      <PlayIcon class="course-card__img-icon" size="24" />
      <div class="course-card__progress-bar-wrapper">
        <ProgressBar :value="item.user_status.progress" />
      </div>
    </template>
    <template #content>
      <GroupItemCardContent>
        <template #top-line>
          <p class="course-card__difficulty">{{ item.difficulty }}</p>
        </template>
        <template #mid-line>
          <p>{{ item.name }}</p>
        </template>
        <template #bot-line>
          <p
            class="course-card__learning-area"
            :class="`course-card__learning-area--${learningAreaColorClass}`"
          >
            {{ learningAreaLabel }}
          </p>
          <div class="course-card__divider" />
          <p class="course-card__instructors-counter">
            {{ item.instructors[0].name }}
            {{ instructorsPlus ? '+' + instructorsPlus : '' }}
          </p>
          <div class="course-card__divider" />
          <p class="course-card__duration">
            {{ courseDuration }}
          </p>
        </template>
      </GroupItemCardContent>
    </template>
    <template #button>
      <PlayIcon :size="playIconSize" />
    </template>
  </GroupItemCard>
</template>

<script>
import { PlayIcon } from 'vue-feather-icons'
import { toKebabCase } from '@/helpers'
import ProgressBar from './ProgressBar.vue'
import { GroupItemCard, GroupItemCardContent } from '.'

export default {
  name: 'CourseItemCard',
  inject: ['getBreakpoint'],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  components: {
    ProgressBar,
    GroupItemCard,
    GroupItemCardContent,
    PlayIcon,
  },
  computed: {
    imgBackground() {
      return {
        backgroundImage: `url(${this.item.images.small_image_url ||
          this.item.images.main_image_url})`,
      }
    },
    playIconSize() {
      const breakpoint = this.getBreakpoint()

      switch (breakpoint) {
        case 'mobile':
          return '16'

        case 'tablet':
          return '20'

        default:
          return '24'
      }
    },
    learningAreaColorClass() {
      return toKebabCase(this.learningAreaLabel)
    },
    learningAreaLabel() {
      const { main_learning_area, learning_areas } = this.item

      return main_learning_area || learning_areas[0]
    },
    instructorsPlus() {
      return this.item.instructors.length - 1
    },
    courseDuration() {
      const { duration_in_seconds: duration } = this.item
      return this.$duration.durationFromSecs(duration)
    },
  },
  methods: {
    goToCourse() {
      const { uuid, slug } = this.item
      const learning_areas = [{ name: this.learningAreaLabel }]
      const link = {
        objectID: uuid,
        slug,
        learning_areas,
      }

      this.$router.push(this.$buildContentLink('course', link))
    },
  },
}
</script>

<style lang="scss" scoped>
p {
  margin: 0px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.course-card {
  &__img-icon {
    margin-top: 42px;

    @include desktop {
      margin-top: 25px;
    }
  }
  &__progress-bar-wrapper {
    width: 100%;
    margin-top: 20px;
    padding: 0px 10px;
  }
  &__difficulty {
    text-transform: capitalize;
  }
  &__learning-area {
    &:before {
      content: '';
      width: 8px;
      height: 8px;
      border-radius: 50%;
      display: inline-block;
      margin-right: 5px;
    }

    &--networking {
      &:before {
        background: var(--larea-networking);
      }
    }
    &--cloud {
      &:before {
        background: var(--larea-cloud);
      }
    }
    &--data-science {
      &:before {
        background: var(--larea-data-science);
      }
    }
    &--cyber-security {
      &:before {
        background: var(--larea-cyber-security);
      }
    }
    &--it-essentials {
      &:before {
        background: var(--larea-it-essentials);
      }
    }
    &--development {
      &:before {
        background: var(--larea-development);
      }
    }
  }
  &__divider {
    border-left: 1px solid var(--tundora-gray);
    align-self: stretch;
  }
}
</style>
